module.exports = __webpack_public_path__ + "img/12.4ddec441.jpg";